import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled, { css } from "styled-components"
import { rem } from "polished"
import { Link } from "@outdoormap/gatsby-plugin-brand-sites"

import { Heading4 } from "../styled/heading"

export default function Menus() {
  const { config, pages } = useStaticQuery(graphql`
    query {
      pages: allPagesJson {
        nodes {
          path
          title
        }
      }

      config: configJson {
        types {
          slug
          title
          name
        }

        footer {
          types
          explore {
            title
            items {
              url
              title
            }
          }
        }
      }
    }
  `)

  return (
    <Container>
      <Group>
        <Heading4
          as="h2"
          dangerouslySetInnerHTML={{ __html: config.footer.types }}
        />

        <ul>
          {config.types.map((type, i) => (
            <li key={i}>
              <Link to={`/${type.slug}`}>{type.title}</Link>
            </li>
          ))}
        </ul>
      </Group>

      <Group $secondary={true}>
        <Heading4
          as="h2"
          dangerouslySetInnerHTML={{
            __html: config.footer.explore.title,
          }}
        />

        <ul>
          {config.footer.explore.items.map((item, i) => (
            <li key={i}>
              <Link to={item.url}>{item.title}</Link>
            </li>
          ))}

          {pages.nodes.length > 0 &&
            pages.nodes.map((item, i) => (
              <li key={i}>
                <Link to={item.path}>{item.title}</Link>
              </li>
            ))}
        </ul>
      </Group>
    </Container>
  )
}

const Container = styled.div`
  display: flex;

  @media ${({ theme }) => theme.mq.xlargeDown} {
    justify-content: center;
  }

  @media ${({ theme }) => theme.mq.smallDown} {
    flex-direction: column;
  }

  > *:not(:last-child) {
    margin-right: 5em;

    @media ${({ theme }) => theme.mq.smallDown} {
      margin-bottom: 2.5em;
      margin-right: 0;
    }
  }
`

const Group = styled.section`
  ${Heading4} {
    ${({ theme }) => theme.fonts.set(`primary`, `bold`)};

    margin-bottom: ${rem(15)};
    white-space: nowrap;
    color: ${({ theme }) => theme.colors.greenOpaque};
  }

  ul {
    font-size: ${rem(18)}; /* 24 */
    column-count: 2;
    column-gap: 4em;

    ${({ $secondary }) =>
      $secondary &&
      css`
        font-size: 1.125em; /* 18 */
      `}

    @media ${({ theme }) => theme.mq.xlargeDown} {
      column-count: 1;
    }
  }

  li {
    margin-bottom: 0.6em;
    line-height: 1;
    transition: opacity 0.2s linear;
    width: 100%;
    clear: both;
    display: inline-block;

    &:hover {
      opacity: 0.7;
    }

    &:active {
      transition: none;
      opacity: 0.4;
    }
  }
`
